import { DriverStandings, IDriverStandings } from '@sky-it-livedata/livedata-sports-design-system';
// import { graphql } from "appsync";

import transformQuery from "./transformers/query-transformer";
// import transformSubscription from "./transformers/subscription-transformer";
import { LgpResultsQuery, } from "./types";
import { log } from "../../utils/log";
// import { useSubscription } from "../../hooks/useSubscription";
import { WidgetContext } from "../../types/WidgetContext";
import { useIntcmp } from '../../hooks/useIntcmp';

export const setCustomAttributes = ({variables}: WidgetContext<LgpResultsQuery>) => {
  return {
    variables: JSON.stringify(variables),
  };
}

// const subscriptionDocument = graphql("subscription UpdateLgpResultsWidget($gpId: ID!, $sessionName: String!) {\n  onUpdateLgpResultsWidgetByGpIdAndSessionName(\n    gpId: $gpId\n    sessionName: $sessionName\n  ) {\n    gpId\n    gpStatus\n    isCurrent\n    seasonAndCompId\n    sessionName\n    ranking {\n      link\n      text\n    }\n    results {\n      link\n      text\n    }\n    calendar {\n      link\n      text\n    }\n    gpInfo {\n      customGpName\n      gpStatus\n      isCurrent\n      isExclusive\n      isSprint\n      lapRecord\n      laps\n      lengthKm\n      startDateTime\n    }\n    sessions {\n      isCurrent\n      sessionInfo {\n        isCurrent\n        sessionLabel\n        sessionName\n        sessionStatus\n        startDateTime\n        details {\n          customDriverName\n          customDriverPageUrl\n          customDriverSurname\n          customTeamName\n          customTeamPageUrl\n          fastestLap\n          flagUrl\n          gap\n          isFastestLap\n          laps\n          position\n          status\n          timing {\n            timeHours\n            timeMilliseconds\n            timeMinutes\n            timeSeconds\n          }\n        }\n      }\n    }\n    seasonAndCompId\n    __typename\n    competitionId\n    seasonId\n  }\n}");

export function getServerProps({
  props,
}: WidgetContext<LgpResultsQuery>): IDriverStandings {
  return transformQuery(props);
}

const LgpResults = ({props,
  variables,
  ...rest
}: WidgetContext<IDriverStandings>) => {
  log({ props, variables, ...rest });

  // const updatedProps = useSubscription<
  //   IDriverStandings,
  //   LgpResultsSubscription,
  //   typeof subscriptionDocument
  // >({
  //   initialData: props,
  //   graphQLDocument: subscriptionDocument,
  //   variables,
  //   transform: transformSubscription,
  //   mergeData: false,
  // }) as IDriverStandings;
  const intCmpEventHandler = useIntcmp();

  return ( 
    <div onClick={intCmpEventHandler}>
      <DriverStandings {...props} />
    </div>
  );
}

export default LgpResults;